export const LOGIN_PATHNAME = "/login";

export const DASHBOARD_PATHNAME = "/home/dashboard";

export const MYPAGE_PATHNAME = "/home/mypage";

export const ANNOUNCEMENT_PATHNAME = "/home/announcement";

export const JOB_STATUS_PATHNAME = "/job/job-status";

export const JOB_PLANNING_PATHNAME = "/job/job-planning";

export const SEARCHED_PATHNAME = "/searched";

export const STATISTICS_PATHNAME = "/statistics";

export const NETWORK_PATHNAME = "/bioinformatics";

export const AI_HOME_PATHNAME = "/ai-agent";

export const AI_CHAT_PATHNAME = "/ai-agent/chat";

export const AI_SHARE_PATHNAME = "/ai-agent/share";

export const ERROR_PATHNAME = "/error";
